import {FormArray, FormControl, FormGroup} from '@angular/forms';

export class ValidatorHelper {
  public static validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    return true;
  }

  public static validateAllFormArrayFields(formArray: FormArray) {
    formArray.controls.forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        Object.keys(control.controls).forEach(key => {
          control.controls[key].markAsTouched();
        });
      }
    });
    return true;
  }
}
